/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-unsafe-enum-comparison */
/* eslint-disable no-console */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-dynamic-delete */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Badge,
  Button,
  Card,
  CardContent,
  Combobox,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@repo/ui";
import type { MultiSelectChangeEvent } from "@progress/kendo-react-dropdowns";

import {
  CircleX,
  Filter,
  FolderArchive,
  FolderCheck,
  FolderClock,
  FolderClockIcon,
  FolderMinus,
  FolderOpen,
  Folders,
  FolderX,
  Hourglass,
} from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { format } from "date-fns";
import StateChart from "./state-chart";
import GroupChart from "./group-activity-chart";
import ActivityChart from "./activity-chart";
import DashboardCard from "./dashboard-card";
import AccountChart from "./account-chart";
import ProgressBarChart from "./progress-bar-chart";
import type { HubConnection } from "@microsoft/signalr";
import {
  HttpTransportType,
  HubConnectionBuilder,
  LogLevel,
} from "@microsoft/signalr";
import {
  useGetAssignmentGroups,
  useGetCustomers,
  useGetRegions,
} from "utils/apis/lookups.api";
import { useUser } from "hooks/use-user";
import { transformJSON } from "utils/helper";
import {
  useGetDashboardMaintenanceStats,
  useGetDashboardStats,
} from "utils/apis/dashboard.api";
import KendoMultiselect from "ui/multiselect";

type DashboardData = Record<string, any>;

interface UserContextType {
  UserName?: string; // Assuming userId is a string, change if it's a number
  Roles?: string;
}
export default function Dashboard() {
  return <LiveDashboard />;

  // return <MockDashboard />;
}

function LiveDashboard() {
  const { UserName } = useUser() as UserContextType;
  const [isFullScreen, setIsFullScreen] = useState<boolean>(false);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [selectedDashboard, setSelectedDashboard] = useState<string>(
    "MIS – Command Centre Dashboard"
  );
  const [filters, setFilters] = useState<any>({
    date: {
      name: "All",
      id: "all",
    },
  });
  const [selectedAccounts, setSelectedAccounts] = useState<any>([]);
  const [selectedRegions, setSelectedRegions] = useState<any>([]);
  const [selectedAssignmentGroups, setSelectedAssignmentGroups] = useState<any>(
    []
  );
  const [dashboardData, setDashboardData] = useState<DashboardData | null>(
    null
  );
  const [ticketsStats, setTicketsStats] = useState<DashboardData | null>(null);
  const [maintenanceStats, setMaintenanceStats] =
    useState<DashboardData | null>(null);
  const [connection, setConnection] = useState<HubConnection | null>(null);
  const { Roles } = useUser() as UserContextType;
  const isCCAdmin = Roles?.includes("CC Dashboard");
  const { data: customers } = useGetCustomers();
  const { data: regions } = useGetRegions("UAE");
  const {
    data: dashboardStatsData,
    mutate: getDashboardStats,
    reset: resetStats,
  } = useGetDashboardStats();

  const {
    data: dashboardMaintenanceStatsData,
    mutate: getDashboardMaintenanceStats,
    reset: resetDashboardMaintenanceStats,
  } = useGetDashboardMaintenanceStats();

  const { data: assignmentGroups } = useGetAssignmentGroups();
  const DASHBOARD_URL = process.env.REACT_APP_HUB_URL;
  const nf = Intl.NumberFormat();
  const siteAccessibleKeys = [
    "siteAccessiable",
    "siteAccessiblePercentage",
    "siteNotAccessiable",
    "siteNotAccessiblePercentage",
    "totalSiteAccessiableAndSiteNotAccessiable",
  ];
  const handleClearFilter = (key: string) => {
    const updatedFilter = { ...filters };

    if (key === "date") {
      updatedFilter.date = { name: "All", id: "all" };
    } else {
      delete updatedFilter[key];
    }
    setFilters({ ...updatedFilter });
    if (key === "account") setSelectedAccounts([]);
    if (key === "region") setSelectedRegions([]);
    if (key === "assignmentGroup") setSelectedAssignmentGroups([]);
  };

  const handleChangeFilter = (value: string, key: string) => {
    if (!value) {
      const updatedFilter = { ...filters };
      delete updatedFilter[key];
      setFilters({
        ...updatedFilter,
      });
      return;
    }
    if (["operationDate"].includes(key)) {
      setFilters({
        ...filters,
        [key]: {
          name: format(value, "PPP"),
          id: value,
        },
      });
    } else {
      setFilters({
        ...filters,
        [key]: JSON.parse(value),
      });
    }
  };

  const invokeFilters = transformJSON(filters); // Ensure transformJSON has a valid TypeScript definition
  useEffect(() => {
    if (maintenanceStats && ticketsStats) {
      setDashboardData({ ...ticketsStats, ...maintenanceStats });
    }
  }, [maintenanceStats, ticketsStats]);

  useEffect(() => {
    if (dashboardStatsData) {
      setTicketsStats({
        ...dashboardStatsData,
      });
      resetStats();
    }
    if (dashboardMaintenanceStatsData) {
      const siteAccessibleData: any = {};
      siteAccessibleKeys.forEach((key) => {
        siteAccessibleData[key] = dashboardMaintenanceStatsData[key];
      });
      setMaintenanceStats({ ...siteAccessibleData });
      resetDashboardMaintenanceStats();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dashboardStatsData, dashboardMaintenanceStatsData]);

  useEffect(() => {
    if (isCCAdmin) {
      const withUrl = `${DASHBOARD_URL}/dashboard?userId=${UserName}`;
      const newConnection = new HubConnectionBuilder()
        .configureLogging(LogLevel.Information)
        .withUrl(withUrl, {
          skipNegotiation: true,
          transport: HttpTransportType.WebSockets,
        })
        .withAutomaticReconnect()
        .build();

      setConnection(newConnection);

      const handleConnection = async () => {
        try {
          await newConnection.start();
          console.info("Connected to SignalR hub");

          newConnection.on(
            "notifyserviceticketscommandcenterdashboardstats",
            (data: DashboardData) => {
              console.log(
                "NotifyCommandCenterDashboard Trigger Service Tickets",
                data
              );
              const payload = { ...data };
              siteAccessibleKeys.forEach((elm) => {
                delete payload[elm];
              });

              setTicketsStats(payload);
            }
          );
          newConnection.on(
            "notifymaintenanceservicescommandcenterdashboardstats",
            (data: DashboardData) => {
              console.log(
                "NotifyCommandCenterDashboard Trigger Maintenance",
                data
              );
              const payload: any = {};
              siteAccessibleKeys.forEach((elm) => {
                payload[elm] = data[elm];
              });
              setMaintenanceStats({ ...payload });
            }
          );

          invokeUpdateFilters(newConnection);
        } catch (err) {
          console.error("Error connecting to hub:  Service Tickets", err);
        }
      };

      handleConnection();
      return () => {
        newConnection.off("notifyserviceticketscommandcenterdashboardstats");
        newConnection.off(
          "notifymaintenanceservicescommandcenterdashboardstats"
        );
        newConnection.stop();
      };
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Re-run when userId changes

  const invokeUpdateFilters = async (conn: HubConnection) => {
    if (!conn || conn.state !== "Connected") return;

    try {
      const filterPayload = JSON.stringify({
        date: "",
        account: "",
        region: "",
        assignmentGroup: "",
        fieldEngineer: "",
        ...invokeFilters,
      });
      console.log("invokeFilters", filterPayload);

      await conn.invoke(
        "UpdateCommandDashBoardCenter1SearchCriteria",
        UserName,
        filterPayload
      );
    } catch (err) {
      console.error("Error invoking method:", err);
    }
  };

  useEffect(() => {
    if (isCCAdmin) {
      if (connection && connection.state === "Connected") {
        invokeUpdateFilters(connection);
      }
    } else {
      const _filters = transformJSON(filters);
      getDashboardStats({
        period: _filters?.date || null,
        status: null,
        assignmentGroup: _filters?.assignmentGroup || null,
        activityType: null,
        region: _filters?.region || null,
        customerId: _filters?.account || null,
      });
      getDashboardMaintenanceStats({
        period: _filters?.date || null,
        status: null,
        assignmentGroup: _filters?.assignmentGroup || null,
        activityType: null,
        region: _filters?.region || null,
        customerId: _filters?.account || null,
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  const onAccountChange = (event: MultiSelectChangeEvent) => {
    const _accounts = event.value;
    setSelectedAccounts(_accounts);
    if (_accounts.length > 0) {
      const _accountString = { name: "", id: "" };
      _accounts.forEach((elm: any, index: number) => {
        if (index !== 0) {
          _accountString.name = `${_accountString.name}, ${elm.name}`;
          _accountString.id = `${_accountString.id},${elm.customerId}`;
        } else {
          _accountString.name = `${elm.name}`;
          _accountString.id = `${elm.customerId}`;
        }
      });
      handleChangeFilter(JSON.stringify(_accountString), "account");
    } else {
      handleClearFilter("account");
    }
  };

  const onRegionChange = (event: MultiSelectChangeEvent) => {
    const _regions = event.value;
    setSelectedRegions(_regions);
    if (_regions.length > 0) {
      const _regionString = { name: "", id: "" };
      _regions.forEach((elm: any, index: number) => {
        if (index !== 0) {
          _regionString.name = `${_regionString.name}, ${elm.name}`;
          _regionString.id = `${_regionString.id},${elm.name}`;
        } else {
          _regionString.name = `${elm.name}`;
          _regionString.id = `${elm.name}`;
        }
      });
      handleChangeFilter(JSON.stringify(_regionString), "region");
    } else {
      handleClearFilter("region");
    }
  };

  const onAssignmentGroupChange = (event: MultiSelectChangeEvent) => {
    const _assignmentGroups = event.value;
    setSelectedAssignmentGroups(_assignmentGroups);
    if (_assignmentGroups.length > 0) {
      const _assignmentGroupString = { name: "", id: "" };
      _assignmentGroups.forEach((elm: any, index: number) => {
        if (index !== 0) {
          _assignmentGroupString.name = `${_assignmentGroupString.name}, ${elm.name}`;
          _assignmentGroupString.id = `${_assignmentGroupString.id},${elm.name}`;
        } else {
          _assignmentGroupString.name = `${elm.name}`;
          _assignmentGroupString.id = `${elm.name}`;
        }
      });
      handleChangeFilter(
        JSON.stringify(_assignmentGroupString),
        "assignmentGroup"
      );
    } else {
      handleClearFilter("assignmentGroup");
    }
  };

  useEffect(() => {
    const onFullScreenChange = () => {
      if (!document.fullscreenElement) {
        console.log("Exited fullscreen");
        setIsFullScreen(false);
      } else {
        console.log("Entered fullscreen");
        setIsFullScreen(true);
      }
    };

    document.addEventListener("fullscreenchange", onFullScreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", onFullScreenChange);
    };
  }, []);
  return (
    <div className="px-4 pb-4 dashboard-container overflow-scroll ">
      <div className="flex mb-3 gap-3 justify-between">
        <Popover>
          <PopoverTrigger asChild>
            <Button
              variant="secondary"
              className="w-max rounded-[0.5em]"
              title="Apply Filters"
            >
              Filter <Filter size="1em" className="ml-[0.5em]" />
            </Button>
          </PopoverTrigger>
          <PopoverContent
            align="start"
            className="w-[60vw] dashboard-container"
            onOpenAutoFocus={(e) => {
              e.preventDefault();
            }}
          >
            <h6 className="font-semibold text-lg">Apply Filters</h6>
            <div className="grid grid-cols-3 gap-[0.5em] mt-3 dashboard-container">
              <Combobox
                value={JSON.stringify(filters?.date) || ""}
                popoverContentClass="dashboard-container"
                className="dashboard-container"
                placeholder="Date"
                data={[
                  { label: "Today", value: "today" },
                  { label: "All", value: "all" },
                  { label: "Yesterday", value: "yesterday" },
                  { label: "This Week", value: "thisweek" },
                  { label: "Last Week", value: "lastweek" },
                  { label: "This Month", value: "thismonth" },
                  { label: "Last Month", value: "lastmonth" },
                  { label: "Last 6 Months", value: "last6months" },
                  { label: "Last 9 Months", value: "last9months" },
                  { label: "Last 12 Months", value: "last12months" },
                  { label: "This Quarter", value: "thisquarter" },
                  { label: "last Quarter", value: "lastquarter" },
                  { label: "Last 2 Quarter", value: "last2quarter" },
                  { label: "Last Hour", value: "lasthour" },
                  { label: "Last 2 Hour", value: "last2hour" },
                  { label: "Current Minute", value: "currentminute" },
                  { label: "Last Minute", value: "lastminute" },
                  { label: "Last 15 Minute", value: "last15minute" },
                  { label: "Last 30 Minute", value: "last30minute" },
                  { label: "Last 45 Minute", value: "last45minute" },
                ].map((item) => ({
                  value: JSON.stringify({
                    name: item.label,
                    id: item.value,
                  }),
                  label: item.label,
                }))}
                setValue={(val: string) => {
                  handleChangeFilter(val, "date");
                }}
              />
              <KendoMultiselect
                filterable
                className="dashboard-container"
                data={customers || []}
                textField="name"
                dataItemKey="customerId"
                onChange={onAccountChange}
                value={selectedAccounts}
                placeholder="Accounts..."
                popupSettings={{ className: "dashboard-container" }}
              />

              <KendoMultiselect
                filterable
                className="dashboard-container"
                popupSettings={{ className: "dashboard-container" }}
                data={regions || []}
                onChange={onRegionChange}
                value={selectedRegions}
                textField="name"
                dataItemKey="name"
                placeholder="Regions..."
              />
              {/* <Combobox
                value={JSON.stringify(filters?.region) || ""}
                placeholder="Region"
                data={regions?.map((item: any) => ({
                  value: JSON.stringify({
                    name: item.name,
                    id: item.name,
                  }),
                  label: item.name,
                }))}
                setValue={(val: string) => {
                  handleChangeFilter(val, "region");
                }}
              /> */}

              <KendoMultiselect
                filterable
                className="dashboard-container"
                popupSettings={{ className: "dashboard-container" }}
                data={assignmentGroups || []}
                onChange={onAssignmentGroupChange}
                value={selectedAssignmentGroups}
                textField="name"
                dataItemKey="name"
                placeholder="Assignment Groups..."
              />
              {/* <Combobox
                value={JSON.stringify(filters?.assignmentGroup) || ""}
                placeholder="Assignment Group"
                data={assignmentGroups?.map((item: any) => ({
                  value: JSON.stringify({
                    name: item.name,
                    id: item.name,
                  }),
                  label: item.name,
                }))}
                setValue={(val: string) => {
                  handleChangeFilter(val, "assignmentGroup");
                }}
              /> */}
              <Combobox
                popoverContentClass="dashboard-container"
                value={JSON.stringify(filters?.fieldEngineer) || ""}
                placeholder="Field Engineer"
                data={[{ label: "All", value: "All" }].map((item) => ({
                  value: JSON.stringify({
                    name: item.label,
                    id: item.value,
                  }),
                  label: item.label,
                }))}
                setValue={(val: string) => {
                  handleChangeFilter(val, "fieldEngineer");
                }}
              />
            </div>
          </PopoverContent>
        </Popover>
        {Object.entries(filters as object).length ? (
          <div className="flex gap-2 flex-wrap items-end mr-auto">
            {Object.entries(filters as object).map(
              ([key, val]: [string, { name: string; id: string }]) => (
                <Badge
                  variant="secondary"
                  className="gap-3 pr-1 cursor-pointer text-[length:inherit] py-[0.275em] px-[0.5em]"
                  key={key}
                >
                  <p className="text-sm"> {val.name}</p>

                  <CircleX
                    size="1em"
                    onClick={() => {
                      handleClearFilter(key);
                    }}
                  />
                </Badge>
              )
            )}
          </div>
        ) : null}
        <Select onValueChange={setSelectedDashboard} value={selectedDashboard}>
          <SelectTrigger className="w-[20vw]">
            <SelectValue placeholder="Select Dashboard" />
          </SelectTrigger>
          <SelectContent className="dashboard-container">
            {[
              "MIS – Command Centre Dashboard",
              "MIS – SLA performance of Command Centre",
              "SLA Performance Dashboard",
              "Case SLA by Account",
              "SLA Performance by Account per Field Engineer",
              "FLM/SLM Operations (Summary Dashboard)",
            ].map((item: any) => (
              <SelectItem key={item} value={item}>
                {item}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div
        className={`flex flex-col w-full  ${isFullScreen ? "overflow-scroll" : ""}`}
        ref={containerRef}
      >
        <div className="grid gap-[0.5em] grid-cols-4">
          <DashboardCard
            label="Total Cases"
            value={nf.format(dashboardData?.totalCases || 0)}
            Icon={Folders}
            status="total"
            fontClass="text-6xl text-center text-[#000000]"
            filters={filters}
          />
          <DashboardCard
            label="Open Cases"
            value={nf.format(dashboardData?.openCasesTotal || 0)}
            Icon={FolderOpen}
            status="opentotal"
            fontClass="text-6xl text-center text-[#000000]"
            filters={filters}
          />
          <DashboardCard
            label="Closed"
            value={nf.format(dashboardData?.closedCasesTotal || 0)}
            Icon={FolderMinus}
            status="Closed"
            fontClass="text-6xl text-center text-[#000000]"
            filters={filters}
          />
          <DashboardCard
            label="Cancelled"
            value={nf.format(dashboardData?.cancelledCases || 0)}
            Icon={FolderX}
            status="Cancelled"
            fontClass="text-6xl text-center text-[#000000]"
            filters={filters}
          />
        </div>

        <div className="grid gap-[0.5em] mt-[0.5em] grid-cols-6">
          <DashboardCard
            label="New"
            value={nf.format(dashboardData?.unAssignedCases || 0)}
            Icon={FolderArchive}
            status="Open"
            fontClass="text-7xl text-center text-[#B61C2D]"
            filters={filters}
          />
          <DashboardCard
            label="Assigned"
            value={nf.format(dashboardData?.assignedCases || 0)}
            Icon={FolderCheck}
            status="Assigned"
            fontClass="text-7xl text-center text-[#000000]"
            filters={filters}
          />
          <DashboardCard
            label="In Progress"
            value={nf.format(dashboardData?.inProgressCasesTotal || 0)}
            Icon={FolderClock}
            status="In Progress"
            fontClass="text-7xl text-center text-[#000000]"
            tooltip="Onsite"
            filters={filters}
          />
          <DashboardCard
            label="Awaiting Confirmation"
            value={nf.format(
              dashboardData?.awaitingCustomerConfirmationCases || 0
            )}
            Icon={Hourglass}
            status="Awaiting Customer Approval"
            fontClass="text-7xl text-center text-[#FFAC15]"
            filters={filters}
          />
          <DashboardCard
            label="On Hold"
            value={nf.format(dashboardData?.onHoldCases || 0)}
            Icon={FolderClockIcon}
            status="On Hold"
            fontClass="text-7xl text-center text-[#000000]"
            filters={filters}
          />
          <DashboardCard
            label="Resolved"
            value={nf.format(dashboardData?.resolvedCases || 0)}
            Icon={FolderCheck}
            status="Resolved"
            fontClass="text-7xl text-center text-[#009919]"
            tooltip="Work Completed"
            filters={filters}
          />
        </div>
        <div className="grid gap-4 grid-cols-5 mt-5">
          <ProgressBarChart
            title="Logged Today"
            value={dashboardData?.loggedTodayPercentage}
            count={dashboardData?.loggedToday}
            totalString="100%"
            valueString={`${dashboardData?.loggedTodayPercentage || 0}%`}
            status="Logged Today"
            filters={{
              ...filters,
              loggedToday: { id: "Yes", value: "Yes" },
            }}
          />
          <ProgressBarChart
            title="Carried Over Calls"
            value={dashboardData?.carriedOverCallsPercentage}
            count={dashboardData?.carriedOverCalls}
            totalString="100%"
            valueString={`${dashboardData?.carriedOverCallsPercentage || 0}%`}
            status="Carried Over Calls"
            filters={{
              ...filters,
              carriedOverCalls: { id: "Yes", value: "Yes" },
            }}
          />
          <ProgressBarChart
            title="Vault Access"
            value={dashboardData?.vaultAccessRequiredPercentage}
            count={dashboardData?.vaultAccessRequired}
            totalString="100%"
            valueString={`${dashboardData?.vaultAccessRequiredPercentage || 0}%`}
            status="Vault Access Required"
            filters={{
              ...filters,
              vaultAccessRequired: { id: "Yes", value: "Yes" },
            }}
          />
          <ProgressBarChart
            title="Site Accessible"
            value={dashboardData?.siteAccessiblePercentage}
            valueString={nf.format(dashboardData?.siteAccessiable || 0)}
            totalString={nf.format(
              dashboardData?.totalSiteAccessiableAndSiteNotAccessiable
            )}
            count={dashboardData?.siteAccessiable}
            status="Site Accessible"
            filters={filters}
            disabledNavigation
          />
          <ProgressBarChart
            title="Site Not Accessible"
            value={dashboardData?.siteNotAccessiblePercentage}
            valueString={nf.format(dashboardData?.siteNotAccessiable || 0)}
            totalString={nf.format(
              dashboardData?.totalSiteAccessiableAndSiteNotAccessiable
            )}
            count={dashboardData?.siteNotAccessiable}
            status="Site Not Accessible"
            filters={filters}
            disabledNavigation
          />
        </div>
        <div className="grid grid-cols-4 gap-5 mt-5">
          <Card>
            <CardContent className="p-4 h-full">
              <StateChart
                data={dashboardData?.openCasesByStatusList}
                filters={{ ...filters }}
              />
            </CardContent>
          </Card>
          <Card>
            <CardContent className="p-4 h-full">
              <AccountChart
                data={dashboardData?.openCasesByAccountList}
                filters={{ ...filters }}
              />
            </CardContent>
          </Card>
          <Card>
            <CardContent className="p-4 h-full">
              <GroupChart
                data={dashboardData?.openCasesByAssignmentGroupList}
                filters={{ ...filters }}
              />
            </CardContent>
          </Card>
          <Card>
            <CardContent className="p-4 h-full">
              <ActivityChart
                data={dashboardData?.openCasesByActivityTypeList}
                filters={{ ...filters }}
              />
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}
